/* Core & libraries */
import React, { useEffect, useState } from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */


/* Components */
import UCModal from "../../../ucmodal";
import Content from "./content";
import { ReactComponent as MailSvg } from '../../../../resources/images/mail-icon.svg';

/* Styles */
import styles from "./styles";

const AuDeleteWarningModal = ({ showAuDeleteWarningModal, setShowAuDeleteWarningModal, selectedUser, handleDeleteTeam }) => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <UCModal
      mainModalDivStyling={classes.mainModalDiv}
      className={classes.auDeleteWarningModalModal}
      showModal={showAuDeleteWarningModal}
      setShowModal={setShowAuDeleteWarningModal}
      modalIcon={<MailSvg />}
      modalTitle={<FormattedMessage id="auDeleteWarningModalModal.title" />}
      modalDescription={
        <>
          <p>
            <FormattedMessage id="auDeleteWarningModalModal.description" values={{ name: selectedUser?.name }} />
          </p>
          <p>
            <FormattedMessage id="auDeleteWarningModalModal.description2" />
          </p>
        </>
      }
      modalContent={<Content setShowModal={setShowAuDeleteWarningModal} handleDeleteTeam={handleDeleteTeam} selectedUser={selectedUser} />}
    />
  )
}

export default AuDeleteWarningModal;
